import styled, { css } from "styled-components";
import { Props } from "./types";

export const InvalidResidentialAddressErrorWrapper = styled.section<
  Pick<Props, "isSplashScreen">
>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #f1f1f1;
  ${({ isSplashScreen }) =>
    isSplashScreen &&
    css`
      position: fixed;
      top: 0;
      z-index: 1000;
    `}
`;

export const InvalidResidentialAddressErrorMessages = styled.p`
  margin: 0 28px 12px;
  position: relative;
  text-align: center;
  font-size: 16px;
  & > strong:first-child {
    vertical-align: baseline;
  }
`;

export const IconWrapper = styled.div`
  padding-bottom: 40px;
  position: relative;
  text-align: center;
`;
